import React, { useMemo } from 'react';
import { TitleTextAreaField } from '@warehouse/title/ui';
import { titlePaths } from '@warehouse/title/core';

export function Summary190Field({ localizedInfoUuid }: { localizedInfoUuid: string }) {
	const path = useMemo(() => titlePaths.summary190(localizedInfoUuid), [localizedInfoUuid]);

	return <TitleTextAreaField label="Summary 190" path={path} ariaLabel="Summary 190 Field" />;
}
